import SerpDynamicService from "@services/serp-dynamic-service";
import { initialiseComponents } from "../../core";
import Component from "../component.abstract";
import { hw } from "../helpers/paths";
import { onDisplay } from "../helpers/support";



interface DataSerpProps {
  url: string
  pageSize: number
  type: string | undefined
  IsHttpGet?: boolean // Permet de passer l'appel a l'EntryPoint en méthode HTTP GET (par défaut c'est du POST)
}

export default class DataSerp extends Component {
  private moreButton: HTMLElement;
  private service: SerpDynamicService;
  public data: any;
  public url: string
  public pageSize: number
  constructor(private props: DataSerpProps, element: HTMLElement) {
    super(props, element);
    this.moreButton = this.element.parentElement.querySelector("#plusReco");
    this.url = props.url;
    this.pageSize = props.pageSize ? props.pageSize : 20;
  }

  mounted(): void {
    if (this.props.type) {
      this.element.classList.add(this.props.type);
      if (this.props.type === "responses" && this.moreButton) {
        this.moreButton.innerText = "Voir plus de candidatures";
      }
    }
    onDisplay(this.element, () => {
      if (this.props.url) {
        this.load();
      }
    });
    if (this.moreButton) {
      this.moreButton.addEventListener("click", () => {
        const page = this.moreButton.getAttribute("data-page");
        this.call(page);
        const nextpage = parseInt(page) + 1;
        this.moreButton.setAttribute("data-page", nextpage.toString());
      });
    }
  }
  load(): void {
    // Set the lazy loading
    const lazys = this.element.querySelectorAll("li.lazy");
    for (let i = 0; i < lazys.length; i++) {
      lazys[i].classList.remove("hide");
    }

    // Remove the current offers if it's a reload
    const offers = this.element.querySelectorAll("li[data-serp-offer]");
    for (let i = 0; i < offers.length; i++) {
      offers[i].parentNode.removeChild(offers[i]);
    }
    const emptyLi = this.element.querySelector("li.empty");
    if (emptyLi) {
      emptyLi.parentNode.removeChild(emptyLi);
    }

    if (this.moreButton) {
      this.moreButton.style.display = "flex";
      this.moreButton.setAttribute("data-page", "2");
    }
    // Finally, call the backend
    this.call("1");
  }
  call(page: string): void {
    let pageInt = parseInt(page);
    if (this.props.url && this.pageSize) {
      let pageSize = 10;
      if (pageInt == 1) {
        pageSize = this.pageSize;
      } else {
        // The first page count for 2 pages, so add 1
        pageInt = pageInt + 1;
      }
      if (this.moreButton) this.moreButton.classList.add("loading");

      if (this.props.IsHttpGet) {
        this.service = new SerpDynamicService(this.props.url)
        this.service.addParam('PageIndex', `${parseInt(page)}`)
        this.service.addParam('PageSize', `${pageSize}`)
        this.service.get(this.handleResponse.bind(this));
      } else {
        this.service = new SerpDynamicService(this.props.url)
        this.service.post({ "PageIndex": pageInt, "PageSize": pageSize }, this.handleResponse.bind(this));
      }
      this.service.setErrorHandler((error: any) => {
        this.data = error;
         // Display empty list
        this.displayEmptyResults();
        this.displayResults();
        if (this.moreButton) {
            this.moreButton.style.display = "none";
        }
        initialiseComponents();
      })
    }
  }
  handleResponse(response:any):void {
    this.data = response;
    if (!this.data.items.length) {
      this.displayEmptyResults();
    } else {
      const idx = 0;
      for (let i = 0; i < this.data.items.length; i++) {
        const offer = document.createElement("li");
        offer.setAttribute("class", "hide");
        offer.classList.add("content");
        const dt = '{"serp" : "serp", "idx" : ' + (idx + i) + "}";
        offer.setAttribute("data-serp-offer", dt);
        if (this.props.type) {
          offer.setAttribute("data-type", this.props.type);
        }

        this.element.appendChild(offer);
      }
    }
    // Add GA events
    // tracking on load
    if (this.data.trackingsLoad && this.data.trackingsLoad.length) {
      for (let i = 0; i < this.data.trackingsLoad.length; i++) {
        const trackingLoad = this.data.trackingsLoad[i];
        if (!trackingLoad.event) {
          trackingLoad.event = "VirtualPageview";
        }
        if (trackingLoad.event != "impressionLoad") {
          if (trackingLoad["Compteur-Offre"] >= 1) {
            trackingLoad.typePage = trackingLoad.typePage + "-nonVide";
          } else {
            trackingLoad.typePage = trackingLoad.typePage + "-vide";
          }
          window.dataLayer.push(trackingLoad);
        } else {
          if(window.dataLayer[0].typePage !== "notSend") {
            trackingLoad.typePage = "LO-"+window.dataLayer[0].typePage;
            window.dataLayer.push(trackingLoad);
          } 
        }
      }
    } 
    //tracking nav on click
    if (this.data.trackingsClick && this.data.trackingsClick.length) {
      for (let i = 0; i < this.data.trackingsClick.length; i++) {
        const trackingsClick = this.data.trackingsClick[i];
        if (trackingsClick.typePage != "Home-Connectee") {
          if (!trackingsClick.event) {
            trackingsClick.event = "VirtualPageview";
          }
          if (trackingsClick["Compteur-Offre"] >= 1) {
            trackingsClick.typePage = trackingsClick.typePage + "-nonVide";
          } else {
            trackingsClick.typePage = trackingsClick.typePage + "-vide";
          }
          window.dataLayer.push(trackingsClick);
        }
      }
    }
     if (this.data.isLastPage && this.moreButton) {
       this.moreButton.style.display = "none";
     }

     initialiseComponents();

     if (this.element.className.indexOf("global-lazy-loading") >= 0) {
       // Wait for the other lazy components before displaying the results
       this.element.addEventListener("display", () => {
           this.displayResults()
       });
       this.element.dispatchEvent(new CustomEvent("ready"));
     } else {
       // Just display the results
       this.displayResults();
     }
  }
  displayEmptyResults():void {
     let title = "Il y a sûrement des offres d'emploi pour vous !";
     let message = "";
     if (this.props.type === "offers") {
       message =
         "Dites-nous en plus sur vous pour trouver des offres qui vous correspondent.";
     } else if (this.props.type === "bookmarks") {
       title = "Sauvegardez vos offres d'emploi en favori !";
       message =
         "Lors de votre recherche, si une offre vous plaît, cliquez sur le coeur ❤️<br/>Vous pourrez la retrouver facilement dans votre espace candidat.";
     } else if (this.props.type === "responses") {
       title = "Vous n’avez pas encore candidaté";
       message = "Nous attendons avec impatience vos prochaines candidatures";
     } else {
       message = "On vous prévient dès que c’est le cas ;)";
     }

     let html =
       '<li class="empty">' +
       '<div data-component data-offer-extract class="impact crushed empty-list-warning">' +
       '<svg data-load-url="' +
       hw.getBaseRessourcesUrl() +
       '/img/svg/badges/info.svg"></svg>' +
       "<div>" +
       "<span>" +
       title +
       "</span>" +
       "<span>" +
       message +
       "</span>" +
       "</div>";

     if (this.props.type === "offers" || this.props.type === undefined) {
       const url = "/candidat/profil.html#recherche";
       html += '<a href="' + url + '">Compléter mon profil</a>';
     }

     html += "</div>" + "</li>";
     this.element.innerHTML += html;
  }
  displayResults():void {
     const lazys = document.querySelectorAll("ul[data-serp]>li.lazy");
     const hides = document.querySelectorAll("ul[data-serp]>li.hide:not(.lazy)");

     for (let i = 0; i < lazys.length; i++) {
       lazys[i].classList.add("hide");
     }
     for (let i = 0; i < hides.length; i++) {
       hides[i].classList.remove("hide");
     }

     const block = document.querySelectorAll(".offres-recommand.lazy-loading");
     for (let i = 0; i < block.length; i++) {
       block[i].classList.remove("lazy-loading");
     }
     if (this.moreButton) {
       this.moreButton.classList.remove("loading");
     }
  }
}
